import * as React from 'react';
import {
  AppBar,
  Box,
  IconButton,
  LinearProgress,
  Toolbar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import boostLogWhite from 'assets/images/boost-logo-white.svg';
import LogOutButton from 'shared/components/buttons/logout';
import useRoot from 'hooks/use-root';
import useSidebar from 'features/sidebar/hooks/use-sidebar';
import useAuth from 'features/auth/hooks/use-auth';
import { useEffect, useState } from 'react';
import useHeader from 'features/header/hooks/use-header';
import HeaderSelectMenu from 'features/header/components/header-select-menu';
import { HeaderFeatures } from 'features/header/enums/header-features.enum';
import { PartnerHeaderFeature } from 'features/header/ts-types';
import DefaultHeaderControlsMenu from 'features/header/components/default-header-controls-menu';
import { useSelector } from 'react-redux';
import { StoreState } from 'store';

type Props = {
  onToggleSideBar?: () => void;
};

const Header: React.FC<Props> = (props) => {
  const { defaultPage } = useRoot();
  const { displayBurger } = useSidebar();
  const { globalLoading } = useSelector((state: StoreState) => state.gcash);

  const { state } = useAuth();
  const { headerState, getPartnerHeaderFeatures } = useHeader();
  const [validFeatures, setValidFeatures] = useState<PartnerHeaderFeature[]>(
    []
  );

  useEffect(() => {
    getPartnerHeaderFeatures();
  }, [getPartnerHeaderFeatures]);

  useEffect(() => {
    if (!headerState.listHeaderFeatures) return;

    const sortedFeatures = headerState.listHeaderFeatures
      .map((feature) => ({
        ...feature,
        priorityIndex: feature.config?.priorityIndex ?? Number.MAX_SAFE_INTEGER,
      }))
      .sort((a, b) => a.priorityIndex - b.priorityIndex);

    const usedPriorities = new Set();
    const uniqueByPriority = sortedFeatures.filter((feature) => {
      if (usedPriorities.has(feature.priorityIndex)) return false;
      usedPriorities.add(feature.priorityIndex);
      return true;
    });

    setValidFeatures(uniqueByPriority);
  }, [headerState.listHeaderFeatures]);

  return (
    <Box position="fixed" sx={{ flexGrow: 1 }} zIndex={999}>
      <AppBar>
        <Toolbar sx={{ height: '64px' }}>
          {displayBurger && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={() => props.onToggleSideBar?.()}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box sx={{ flexGrow: 1 }}>
            <Link
              style={{ display: 'flex', alignItems: 'center' }}
              to={defaultPage}
            >
              <img src={boostLogWhite} alt={'boost-logo'} />
            </Link>
          </Box>
          {/*{isAllowedDocumentCounter && <GcashDocumentCountLimiter />}*/}

          {validFeatures?.length > 0 ? (
            validFeatures.map((feature, idx) => {
              switch (feature.type) {
                case HeaderFeatures.DROP_DOWN_MENU:
                  return (
                    <HeaderSelectMenu
                      key={idx}
                      selectItems={feature.config?.items || []}
                      adminEmail={state.userEmail || state.username || 'user'}
                    />
                  );

                case HeaderFeatures.LOGOUT_BUTTON:
                  return <LogOutButton key={idx} />;

                default:
                  return null;
              }
            })
          ) : (
            <DefaultHeaderControlsMenu />
          )}
        </Toolbar>
        <Box sx={{ width: '100%' }}>{globalLoading && <LinearProgress />}</Box>
      </AppBar>
    </Box>
  );
};

export default Header;
